import { get } from '../../networkClient';
import { getCookie } from '../../../utils';
import { Path } from '../path';

export function getFeatureFlags(clientId) {
  // Use useNewBaseUrl=true to hit REACT_APP_SERVER_URL_V2 (apis-v2.residentboost.com)
  // The base URL already includes /apis/v1, so just use /features
  const params = clientId ? { clientId } : null;

  // Add cache-control headers to prevent browser caching issues when clientId changes
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `${getCookie('rb_access_token')}`,
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0'
  };

  return get(Path.GET_FEATURE_FLAGS, params, headers, true, true);
}
